module.exports = __webpack_public_path__ + "static/services-2-cd5c3be010d5b488b01c7ed46e555da9.jpg";